export default "__VITE_ASSET__7669e4aa__"